import { BankruptcyChecklistResponse } from "../api/ClientFileApi";
import { BankruptcyChecklistSection as BankruptcyChecklistSubTab } from "../routes/clientFileRoutes";
import { ChecklistAnswer, ChecklistStatus, QuestionState } from "./BankruptcyChecklist.types";
import { getBankruptcyCapabilityStatus } from "./components/bankruptcy-capability/BankruptcyCapability.utils";
import {
  getBankruptcyConsequencesStatus,
  mapResponseToBankruptcyConsequences,
} from "./components/bankruptcy-consequences/BankruptcyConsequences.utils";
import {
  getDangerousDebtsStatus,
  mapResponseToDangerousDebts,
} from "./components/dangerous-debts/DangerousDebts.utils";
import { getSpecialDebtsStatus, mapResponseToSpecialDebts } from "./components/special-debts/SpecialDebts.utils";

export function computeChecklistStatus<TKey extends string>(
  states: Record<TKey, QuestionState>,
  values: Record<NoInfer<TKey>, ChecklistAnswer>
): ChecklistStatus {
  for (const key of Object.keys(states) as TKey[]) {
    const state = states[key];
    if (!state.visible) {
      continue;
    }
    if (state.isWarning || values[key] === null) {
      return ChecklistStatus.Warning;
    }
  }

  return ChecklistStatus.Complete;
}

export function getChecklistTabStatuses(
  response: BankruptcyChecklistResponse | undefined
): Record<BankruptcyChecklistSubTab, ChecklistStatus> {
  const dangerousDebts = response
    ? getDangerousDebtsStatus(mapResponseToDangerousDebts(response))
    : ChecklistStatus.Warning;
  const specialDebts = response ? getSpecialDebtsStatus(mapResponseToSpecialDebts(response)) : ChecklistStatus.Warning;
  const bankruptcyConsequences = response
    ? getBankruptcyConsequencesStatus(mapResponseToBankruptcyConsequences(response))
    : ChecklistStatus.Warning;

  return {
    [BankruptcyChecklistSubTab.DangerousDebts]: dangerousDebts,
    [BankruptcyChecklistSubTab.SpecialDebts]: specialDebts,
    [BankruptcyChecklistSubTab.BankruptcyCapability]: getBankruptcyCapabilityStatus(response?.bankruptcyCapability),
    [BankruptcyChecklistSubTab.BankruptcyConsequences]: bankruptcyConsequences,
  };
}

export function hasChecklistWarning(response: BankruptcyChecklistResponse | undefined): boolean {
  return Object.values(getChecklistTabStatuses(response)).some((status) => status === ChecklistStatus.Warning);
}
